/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["analyticsContext", "children", "createAnalyticsEvent", "defaultExpanded", "ellipsisLabel", "isExpanded", "itemsAfterCollapse", "itemsBeforeCollapse", "label", "maxItems", "onExpand", "testId"];
import "./breadcrumbs.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, memo, useCallback, useRef, useState } from 'react';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next';
import mergeRefs from '@atlaskit/ds-lib/merge-refs';
import __noop from '@atlaskit/ds-lib/noop';
import { fg } from '@atlaskit/platform-feature-flags';
import { N200 } from '@atlaskit/theme/colors';
import EllipsisItem from './ellipsis-item';
import { useOnRevealed } from './internal/use-on-revealed';
var defaultMaxItems = 8;
var defaultBreadcrumbsLabel = 'Breadcrumbs';
var defaultEllipsisLabel = 'Show more breadcrumbs';
var toArray = React.Children.toArray;
var analyticsAttributes = {
  componentName: 'breadcrumbs',
  packageName: "@atlaskit/breadcrumbs",
  packageVersion: "15.3.10"
};
var noop = __noop;
var interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
var breadcrumbStyles = null;
var InnerBreadcrumbs = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$defaultExpande = props.defaultExpanded,
    defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
    isExpanded = props.isExpanded,
    _props$maxItems = props.maxItems,
    maxItems = _props$maxItems === void 0 ? defaultMaxItems : _props$maxItems,
    _props$itemsBeforeCol = props.itemsBeforeCollapse,
    itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
    _props$itemsAfterColl = props.itemsAfterCollapse,
    itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
    _props$children = props.children,
    children = _props$children === void 0 ? [] : _props$children,
    testId = props.testId,
    _props$onExpand = props.onExpand,
    providedExpanse = _props$onExpand === void 0 ? noop : _props$onExpand,
    analyticsContext = props.analyticsContext,
    _props$label = props.label,
    label = _props$label === void 0 ? defaultBreadcrumbsLabel : _props$label,
    _props$ellipsisLabel = props.ellipsisLabel,
    ellipsisLabel = _props$ellipsisLabel === void 0 ? defaultEllipsisLabel : _props$ellipsisLabel;
  var _useState = useState(defaultExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanse = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isClickedBySpace = _useState4[0],
    setExpansionTrigger = _useState4[1];
  var wrapperRef = useRef(null);
  var isControlled = typeof isExpanded !== 'undefined';
  var isExpansionHandled = providedExpanse !== noop;
  var shouldExpand = isControlled ? isExpanded : expanded;
  var focusFirstRevealed = function focusFirstRevealed() {
    if (wrapperRef.current) {
      var listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
      var interactiveElements = listItems.map(function (li) {
        return li.querySelector(interactiveElementSelector);
      });
      var elementToFocus = interactiveElements[itemsBeforeCollapse];
      var firstInteractiveElement = interactiveElements[0];
      if (elementToFocus) {
        elementToFocus.focus && elementToFocus.focus();
      } else if (firstInteractiveElement) {
        firstInteractiveElement.focus && firstInteractiveElement.focus();
      } else {
        wrapperRef.current.focus();
      }
    }
    setExpansionTrigger(false);
  };
  var focusFirstRevealedMemoized = useCallback(function () {
    if (wrapperRef.current) {
      var listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
      var interactiveElements = listItems.map(function (li) {
        return li.querySelector(interactiveElementSelector);
      });
      var elementToFocus = interactiveElements[itemsBeforeCollapse];
      var firstInteractiveElement = interactiveElements[0];
      if (elementToFocus) {
        elementToFocus.focus && elementToFocus.focus();
      } else if (firstInteractiveElement) {
        firstInteractiveElement.focus && firstInteractiveElement.focus();
      } else {
        wrapperRef.current.focus();
      }
    }
    setExpansionTrigger(false);
  }, [setExpansionTrigger, itemsBeforeCollapse, wrapperRef]);
  useOnRevealed(fg('jfp-magma-stability-platform-3') ? focusFirstRevealedMemoized : focusFirstRevealed, {
    isExpanded: shouldExpand,
    isDisabled: !isClickedBySpace
  });
  var handleExpansion = usePlatformLeafEventHandler(_objectSpread({
    fn: function fn(event, analyticsEvent) {
      if (!isControlled) {
        setExpanse(function (expanded) {
          return !expanded;
        });
      }
      if (isExpansionHandled && isControlled || !isControlled) {
        setExpansionTrigger(event.target === document.activeElement);
      }
      return providedExpanse(event, analyticsEvent);
    },
    action: 'expanded',
    analyticsData: analyticsContext
  }, analyticsAttributes));
  var childrenArray = toArray(children);
  var breadcrumbsArray = React.Children.map(childrenArray, function (child, index) {
    //To avoid error if child is a string
    if (typeof child === 'string') {
      return child;
    }
    return childrenArray.length - 1 === index ?
    /*#__PURE__*/
    // eslint-disable-next-line @repo/internal/react/no-clone-element
    React.cloneElement(child, {
      'aria-current': 'page'
    }) : child;
  });
  var renderItemsWithEllipsis = function renderItemsWithEllipsis() {
    var allItems = breadcrumbsArray;
    // This defends against someone passing weird data, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem
    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      return allItems;
    }
    var beforeItems = allItems.slice(0, itemsBeforeCollapse);
    var afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
    return [].concat(_toConsumableArray(beforeItems), [/*#__PURE__*/React.createElement(EllipsisItem, {
      key: "ellipsis",
      testId: testId && "".concat(testId, "--breadcrumb-ellipsis"),
      onClick: handleExpansion,
      label: ellipsisLabel
    })], _toConsumableArray(afterItems));
  };
  var shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
  var breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": label,
    ref: mergeRefs([ref, wrapperRef]),
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("ol", {
    "data-testid": testId,
    className: ax(["_1e0c1txw _1n261g80 _syazpsu8 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"]),
    style: {
      "--_vrm7dk": ix("var(--ds-text-subtlest, ".concat(N200, ")"))
    }
  }, breadcrumbsItems));
});
var Breadcrumbs = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var analyticsContext = _ref.analyticsContext,
    children = _ref.children,
    createAnalyticsEvent = _ref.createAnalyticsEvent,
    defaultExpanded = _ref.defaultExpanded,
    ellipsisLabel = _ref.ellipsisLabel,
    isExpanded = _ref.isExpanded,
    itemsAfterCollapse = _ref.itemsAfterCollapse,
    itemsBeforeCollapse = _ref.itemsBeforeCollapse,
    label = _ref.label,
    maxItems = _ref.maxItems,
    onExpand = _ref.onExpand,
    testId = _ref.testId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(InnerBreadcrumbs, _extends({}, props, {
    analyticsContext: analyticsContext,
    children: children,
    createAnalyticsEvent: createAnalyticsEvent,
    defaultExpanded: defaultExpanded,
    ellipsisLabel: ellipsisLabel,
    isExpanded: isExpanded,
    itemsAfterCollapse: itemsAfterCollapse,
    itemsBeforeCollapse: itemsBeforeCollapse,
    label: label,
    maxItems: maxItems,
    onExpand: onExpand,
    ref: ref,
    testId: testId
  }));
}));

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Breadcrumbs;